export * from './Rx';
import * as _testing from 'rxjs/testing';
export var testing = _testing;
import * as _ajax from 'rxjs/ajax';
export var ajax = _ajax;
import * as _webSocket from 'rxjs/webSocket';
export var webSocket = _webSocket;
//# sourceMappingURL=umd.js.map